import {styled, Theme} from "@mui/material/styles";
import {Grid} from "@mui/material";

type MapActiveProps = {
  isMapActive: boolean
}

export const SearchResultsContainer = styled(Grid, {
  shouldForwardProp: (propName: PropertyKey) => propName !== 'isMapActive'
})(({theme, isMapActive}: { theme: Theme } & MapActiveProps) => ({
  paddingTop: '.06em',
  overflow: 'visible',
  height: 'auto',
  [theme.breakpoints.down('lg')]: {
    width: '100%',
    // Map view: the search header on top, the map filling the screen under it and the navbar.
    ...(isMapActive && {
      flexDirection: 'column',
      flexWrap: 'nowrap',
      height: 'calc(100dvh - 80px)',
    }),
  }
}));

export const MainGridContainer = styled(Grid, {
  shouldForwardProp: (propName: PropertyKey) => propName !== 'showRequestLocationForm'
})(() => ({
  minHeight: '75vh',
  position: "relative",
  overflow: 'visible'
}));

export const LeftContainer = styled(Grid, {
  shouldForwardProp: (propName: PropertyKey) => propName !== 'isMapActive'
})(({theme, isMapActive}: { theme: Theme } & MapActiveProps) => ({
  width: "48em",
  height: 'fit-content',
  // At least as tall as the map, with the footer at the bottom even under a short list.
  display: 'flex',
  flexDirection: 'column',
  minHeight: 'calc(100vh - 80px)',
  maxHeight: 'none',
  border: 'none',
  overflow: 'visible',
  [theme.breakpoints.down('lg')]: {
    width: "100%",
    // Map view keeps only the search form (search, List / Map, filters) above the map.
    ...(isMapActive && {
      flex: 'none',
      minHeight: 0,
      '& > :not(form)': {display: 'none'},
    }),
  },
}));
